import { EntityStatus, ServiceProviderActions } from "../Constants/Constants";

/**
 * @param {*} data : response from get all providers api
 * @returns Array of objects as required by service provider table
 */
export const convertServiceProviderList = (data) => {
  const list = data.serviceProviders || [];
  return list.map((item) => {
    return {
      key: item.providerid,
      providerId: item.providerid,
      providerCode: item.providercode,
      name: item.providername,
      dispName: item.displayname,
      type: item.providertype,
      status: item.providerstatus,
    };
  });
};

/**
 * @param {*} data : reponse from get provider details using provider id api
 * @returns Object formatted as required by service provider form initial values
 */
export const convertProviderApiToFormValues = (data) => {
  const provider = data.serviceProvider || {};
  return {
    name: provider.providername,
    dispName: provider.displayname,
    providerCode: provider.providercode,
    type: provider.providertype,
    location: provider.locationinfo?.name,
    status: provider.providerstatus,
    description: provider.description,
    website: provider.website,

    adminName: provider.admincontact?.name,
    adminPhone: provider.admincontact?.phone,
    adminEmail: provider.admincontact?.email,
    adminDesc: provider.admincontact?.description,

    techName: provider.technicalcontact?.name,
    techPhone: provider.technicalcontact?.phone,
    techEmail: provider.technicalcontact?.email,
    techDesc: provider.technicalcontact?.description,

    commName: provider.commercialcontact?.name,
    commPhone: provider.commercialcontact?.phone,
    commEmail: provider.commercialcontact?.email,
    commDesc: provider.commercialcontact?.description,

    storeUserdata: provider.store_userdata,
    apiEndpoint: provider.api_endpoint,
    apiUsername: provider.api_username,
    apiPassword: provider.api_password,
    apiAuthtype: provider.api_authtype,
    apiClientId: provider.api_clientid,
    apiClientSecret: provider.api_clientsecret,
    apiPlugin: JSON.stringify(provider.api_plugin, null, 4),
  };
};

/**
 * @param {*} data : service provider form submitted values
 * @param {*} action : action type: add or edit
 * @returns Object formatted as required by create or update api
 */
export const convertProviderFormToApiValues = (
  data,
  action = ServiceProviderActions.add
) => {
  const returnData = {
    displayname: data.dispName,
    description: data.description,
    providercode: data.providerCode,
    providertype: data.type,
    locationinfo: { name: data.location },
    website: data.website,

    store_userdata: data.storeUserdata,
    api_endpoint: data.apiEndpoint,
    api_authtype: data.apiAuthtype,
    api_username: data.apiUsername,
    api_password: data.apiPassword,
    api_clientid: data.apiClientId,
    api_clientsecret: data.apiClientSecret,
    api_plugin: data.apiPlugin ? JSON.parse(data.apiPlugin) : undefined,
  };

  if (data.adminName || data.adminEmail || data.adminPhone || data.adminDesc) {
    returnData.admincontact = {
      name: data.adminName,
      email: data.adminEmail,
      phone: data.adminPhone,
      description: data.adminDesc,
    };
  }
  if (data.techName || data.techEmail || data.techPhone || data.techDesc) {
    returnData.technicalcontact = {
      name: data.techName,
      email: data.techEmail,
      phone: data.techPhone,
      description: data.techDesc,
    };
  }
  if (data.commName || data.commEmail || data.commPhone || data.commDesc) {
    returnData.commercialcontact = {
      name: data.commName,
      email: data.commEmail,
      phone: data.commPhone,
      description: data.commDesc,
    };
  }

  if (action === ServiceProviderActions.add) {
    returnData.providername = data.name;
    returnData.providerstatus = EntityStatus.ACTIVE;
  }
  if (action === ServiceProviderActions.edit) {
    returnData.providerid = data.id;
  }
  return returnData;
};

/**
 * @param {*} data : reponse from get tenant list api
 * @returns Array of objects containing key and name
 */
export const convertProviderTenantApiToList = (data) => {
  const list = data.tenants || [];
  return list.map((item) => {
    return {
      providerId: item.tenantproviderid,
      name: item.tenantprovidername,
    };
  });
};

/**
 * @param {*} data : Array of provider tenant ids selected for adding
 * @returns Object formatted as required by update service provider tenants api
 */
export const convertProviderTenantListToApi = (data) => {
  const returnData = { tenants: [] };
  data.forEach((provId) => {
    returnData.tenants.push({ tenantproviderid: provId });
  });
  return returnData;
};

/**
 * @param {*} data : response from get all service provider api
 * @returns Array of objects as required by service provider dropdown
 */
export const convertServiceProviderListToDropdown = (data) => {
  const list = data.serviceProviders || [];
  return list.map((item) => {
    return {
      providerId: item.providerid,
      providerName: item.providername,
    };
  });
};

/**
 * @param {*} data : response from get all tenants for given service provider
 * @returns Array of objects as required by service provider dropdown
 */
export const convertServiceProviderTenantListToDropdown = (data) => {
  const list = data.tenants || [];
  return list.map((item) => {
    return {
      providerId: item.tenantproviderid,
      providerName: item.tenantprovidername,
    };
  });
};
